import React from 'react';
import AddCircleIcon from '@material-ui/icons/AddCircle'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import Divider from '@material-ui/core/Divider';
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox'
import FormLabel from '@material-ui/core/FormLabel'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Result from './result'
import 'react-quill/dist/quill.bubble.css'


const singlequestionstyle = {
  margin:'5px'
}

const cardstyle = {
  margin : '1em'
}

export default class LectureQuiz extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      version: false,
      hints : '',
      mustreach : 0.5,
      questions : [],
      qcount : 0,
      activeTab: 0,
    }
  }




  handleTabChange = (event, newValue) => {
    this.setState({ activeTab: newValue });
  }

  renderQuizQuestions() {
    return (
      <>
        {!this.props.blocked && this.props.questions && this.props.questions.map((q,i) =>
          <Paper key={i} className="ql-bubble" style={singlequestionstyle}>
            {q.text && <div className="question ql-editor" dangerouslySetInnerHTML={{__html: q.text}}></div>}
            <FormGroup>
                {q.answers && q.answers.map((a,j) =>
                  <div key={j}>
                {  a.text &&
                      <FormLabel className="answer">
                            <Checkbox
                              checked={a.checked}
                              onChange={event => this.props.modQuiz(event.target.checked,i,j)}
                              value={q,i,a,j}
                            />
                            <div className="answertext" dangerouslySetInnerHTML={{__html: a.text}}></div>
                      </FormLabel> }
                  </div>
                )}
            </FormGroup>
          </Paper>
        )}
        {this.props.blocked &&
          <div>
              <img src="https://fb.rdheinsberg.de/rest/image/rdhsheadlogo.jpg" alt="RDHS Logo"/>
                <b>Bitte zuerst das Video anschauen!</b>
          </div>
        }
        <Button onClick={this.props.checkQuiz}>
          <AddCircleIcon />Absenden
        </Button>
      </>
    );
  }

  renderPreviousResults() {
    return (
      <div>
        <img src="https://fb.rdheinsberg.de/rest/image/rdhsheadlogo.jpg" alt="RDHS Logo"/>
        {this.props.prevQ.map((q,i) => (
          <Result key={i} {...this.props} result={q}/>
        ))}
        {this.props.resubmittable &&
          <Button variant="contained" color="secondary" onClick={this.props.newQuiz}>
            <AddCircleIcon />Neuer Versuch
          </Button>
        }
        {!this.props.resubmittable &&
          (this.props.prevQ.every((q,i) => (!q.passed)) ?
          <div>Alle Versuche verbraucht. Bitte melde dich über fortbildung-intern@rd-heinsberg.de wegen des weiteren Vorgehens.</div>
          :
          <div>Teilnahme erfolgreich.</div>)
        }
      </div>
    );
  }

  render () {
    const { submitted, prevQ } = this.props;
    const { activeTab } = this.state;
    const showTabs = !submitted && prevQ && prevQ.length > 0;

    return (
      <div>
        <Divider/>
        {showTabs && (
          <>
            <Tabs
              value={activeTab}
              onChange={this.handleTabChange}
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab label="Aktueller Test" />
              <Tab label="Bisherige Ergebnisse" />
            </Tabs>
            {activeTab === 0 && this.renderQuizQuestions()}
            {activeTab === 1 && this.renderPreviousResults()}
          </>
        )}
        {!submitted && !showTabs && this.renderQuizQuestions()}
        {submitted && this.renderPreviousResults()}
      </div>
    )
  }


}
